import Link from "next/link";
import { Tab } from "@shared/UI/Tabs";
import { QuestionAnswer } from "./instructorPanel";
import { DOCUMENT_LINKS } from "../constants/DOCUMENTS_LINKS";

export const faqSections: Tab[] = [
	{
		id: 0,
		title: "Создание курса",
	},
	{
		id: 1,
		title: "Правила платформы",
	},
	{
		id: 2,
		title: "Поддержка",
	},
	{
		id: 3,
		title: "Финансы",
	},
	{
		id: 4,
		title: "Юридические вопросы",
	},
];

export const createCourseQAs: QuestionAnswer[] = [
	{
		id: 0,
		question: "1. Есть ли максимальный хронометраж платного курса?",
		answer: "Максимального хронометража курса нет.",
	},
	{
		id: 1,
		question: "2. Есть ли ограничения по количеству размещенных мной платных/бесплатных курсов на платформе?",
		answer: "Ограничений на количество курсов нет.",
	},
	{
		id: 2,
		question: "3. Мой курс должен содержать видеоуроки? Я должен(на) быть в кадре?",
		answer:
			"Уже сейчас на нашей платформе можно размещать как видеофайлы, так и дополнительные материалы для скачивания. А уже в ближайшее время также появятся возможности по добавлению текстового и аудио контента.\n" +
			"Конечно же, необязательно быть в кадре. Но помните! Уровень доверия аудитории всегда выше, когда она понимает, кто с ней говорит. А, значит, и откликов будет больше. \n",
	},
	{
		id: 3,
		question:
			"4. Курс могут вести несколько преподавателей? А также могут ли быть в кадре сразу несколько человек?",
		answer:
			"Если для вашего курса важно, чтобы преподавателей было несколько - делайте именно так! Форма подачи материала - это ваш выбор! Главное помнить, что курс может быть добавлен в личном кабинете только у одного автора.",
	},
	{
		id: 4,
		question: "5. Должен ли автор иметь какое-либо образование?",
		answer:
			"Михаил Калашников, Стив Джобс, Квентин Тарантино - все они не имели ни высшего, ни специального образования. Но им точно всегда было чем поделиться с другими. Мы верим, что каждый автор профессионал в своём деле, и это не требует дополнительных доказательств.",
	},
	{
		id: 5,
		question: "6. Если на платформе уже есть курс по такой же теме, как у меня, платформа разместит его?",
		answer:
			"Конечно, да. Даже «Черных квадратов» было написано, как минимум семь. Причем не только Казимиром Малевичем. Мы уверены, что ваш уникальный опыт отличается от опыта других авторов. Ограничений по количеству размещений нет. ",
	},
	{
		id: 6,
		question:
			"7. Я не хочу указывать мое настоящее имя. Могу я использовать только никнейм и опубликовать курс?",
		answer:
			"Вы можете опубликовать курс под никнеймом или вашим псевдонимом, но мы рекомендуем использовать настоящее имя. Пользователям важно знать, кто с ними говорит. Это повышает уровень доверия и улучшает обратную связь.",
	},
	{
		id: 7,
		question: "8. Могу ли я загрузить курс на иностранном языке?",
		answer: "В данный момент платформа предусмотрена только для русскоговорящих пользователей.",
	},
	{
		id: 8,
		question:
			"9. Я хочу поставить в видео субтитры на другом языке. Платформа предусматривает такую возможность?",
		answer: "В данный момент на платформе такой возможности нет.",
	},
];

export const platformRulesQAs: QuestionAnswer[] = [
	{
		id: 0,
		question: "1. Занимается ли платформа продвижением курсов?",
		answer:
			"Да, конечно. Мы тоже заинтересованы в продвижении курса. Наши SEO-специалисты сделают так, чтобы он отобразился в поисковых строках, а команда по SMM расскажет о нем в наших социальных сетях и у других блогеров.",
	},
	{
		id: 1,
		question: "2. Есть ли ограничения по времени размещения курса на платформе?",
		answer: "Нет, ограничений нет.",
	},
	{
		id: 3,
		question: "3.Могу ли я разместить свой курс на нескольких площадках?",
		answer: "Да, вы можете разместить ваш курс на сторонних площадках.",
	},
	{
		id: 4,
		question: "4. Меня оскорбляет пользователь. Могу ли я его заблокировать?",
		answer:
			"Обратитесь в техническую поддержку, чтобы подать жалобу на конкретного пользователя. Но мы стараемся предотвращать такие проблемы на ранней стадии. Наши модераторы постоянно следят за тем, чтобы правила платформы не нарушались.",
	},
	{
		id: 5,
		question: "5. Я обязан(а) оставлять личную информацию и контактные данные для учащихся?",
		answer: "Предоставление личных данных и контактов ученикам необязательно.",
	},
	{
		id: 6,
		question:
			"6. Слушатели смогут оставлять комментарии и отзывы под моим курсом и будут ли это видеть другие пользователи?",
		answer:
			"Да, каждый зарегистрированный пользователь, купивший курс, может оставить отзыв и оценку на странице курса, а также разместить комментарий или задать вопрос под отдельным видеоуроком. Отзывы и оценки будут видны всем пользователям, коментарии под видеоуроками внутри курса доступны только пользователям, купившим курс.",
	},
];

export const supportQAs: QuestionAnswer[] = [
	{
		id: 0,
		question: "1. Где я могу увидеть статистику по моему курсу?",
		answer:
			"Во вкладке “Финансы” в вашем личном кабинете вы можете увидеть количество покупок курса и сумму от продаж курса. На странице курса вы можете посмотреть, сколько всего у вас студентов.",
	},
	{
		id: 1,
		question: "2. Есть ли у платформы техническая поддержка?",
		answer:
			"Да, вы можете воспользоваться формой обратной связи или написать на почту support@selfschool.ru. Поддержка работает 24/7. После обработки запроса наши специалисты свяжутся с вами в кратчайшие сроки.",
	},
	{
		id: 2,
		question: "3. Могу ли я общаться со своими слушателями на платформе?",
		answer:
			"В настоящее время на платформе предусмотрена система ответов через комментарии и отзывы под лекциями/видеоуроками.",
	},
	{
		id: 3,
		question: "4. Есть ли мобильное приложение Selfschool?",
		answer: "На данный момент доступна веб-версия сайта на мобильных устройствах.",
	},
	{
		id: 4,
		question: "5. Какие минимальные технические требования нужны для размещения моего курса на платформе?",
		answer:
			"Требования к изображениям - не более 40 мб, форматы: jpeg, png, gif, jpg. К видео - одно видео не более 4 Гб, качество изображения - не ниже 720p, форматы: mp4, avi, mov, m4p. Подробнее о том, как загрузить курс на платформу Selfschool, вы узнаете по ссылке в футере главной страницы “Гайд для авторов”. https://selfschool.ru/docs/guide_for_authors.pdf\n",
	},
	{
		id: 5,
		question: "6. Как мне загрузить курс на платформу?",
		answer:
			"Мы создали доступный “Гайд для авторов”, https://selfschool.ru/docs/guide_for_authors.pdf где подробно описан процесс размещения курса на платформе Selfschool. Если у вас возникнут сложности, обратитесь в нашу службу технической поддержки.  support@selfschool.ru ",
	},
	{
		id: 6,
		question: "7. Мой курс не прошел модерацию. Что делать?",
		answer:
			"На почту, указанную вами при регистрации, будет отправлено письмо, где будут обозначены причины отклонения курса модератором. Если у вас возникнут вопросы, обратитесь в нашу службу технической поддержки. support@selfschool.ru",
	},
	{
		id: 7,
		question: "8. Проходят ли курсы модерацию перед размещением на платформе?",
		answer:
			"Да, команда платформы проверяет курсы перед размещением на предмет соответствия условиям и требованиям платформы. За содержание курса, за незаконную, недостоверную, неполную, ложную, неточную, ошибочную, неактуальную или искаженную информацию, размещенную пользователем, платформа ответственности не несет.",
	},
];

export const financesQAs: QuestionAnswer[] = [
	{
		id: 0,
		question: "1. В какой валюте можно оценивать стоимость моего курса?",
		answer:
			"На данный момент мы ведем нашу деятельность в РФ и странах СНГ, поэтому все финансовые операции проводим только в рублях.",
	},
	{
		id: 1,
		question: "2. Картами каких банков можно оплачивать мой курс?",
		answer: "Курсы размещенные на платформе, можно оплачивать картой любых российских банков.",
	},
	{
		id: 2,
		question: "3. Как быстро я получу деньги за проданный курс (процент)?",
		answer:
			"Выплата за проданный курс осуществляется в день подачи заявки, но не позднее трех рабочих дней с момента подачи. Комиссия за вывод денежных средств на карту составляет 0,9%, но не менее 30 рублей. Поэтому Selfschool рекомендует выводить средства, когда на вашем счету накопится сумма в размере не менее 3500 рублей.",
	},
	{
		id: 3,
		question: "4. Как мне определить самостоятельно стоимость моего курса на платформе?",
		answer:
			"Стоимость курса автор назначает самостоятельно от бесплатного до 15000 руб. Но есть несколько рекомендаций от нас: Изучите стоимость курсов по Вашей теме на нашей платформе и в других источниках. Если Ваш курс не имеет принципиальных отличий от других курсов, рекомендуем незначительно снизить его стоимость и тем самым привлечь учащихся. И не забывайте: чем выше стоимость Вашего курса, тем больше вопросов перед покупкой возникнет у учащихся. Им будет интересно, чем отличается Ваш курс от других, почему стоит дороже, какой результат они получат.",
	},
	{
		id: 4,
		question: "5. Смогу ли я получить бОльший процент комиссии, если приведу своих слушателей на платформу?",
		answer: "На данном этапе мы находимся в процессе разработки реферальных ссылок для авторов. ",
	},
	{
		id: 5,
		question: "6. Может ли слушатель попросить вернуть деньги, если ему не понравится мой курс?",
		answer:
			"После получения доступа к курсу вернуть средства нельзя. Если денежные средства списаны, а доступ не получен по техническим или другим исключительным причинам, необходимо написать в техподдержку, чтобы администратор платформы рассмотрел ситуацию индивидуально и принял решение о возврате средств. Также, мы рекомендуем Авторам делать небольшие части курса бесплатными для предварительного просмотра, чтобы избежать возможности возникновения претензий.",
	},
	{
		id: 6,
		question:
			"7. Могу ли я привязать карту другого человека в личном кабинете для зачисления денежных средств с продажи моего курса?",
		answer:
			"Да, вы можете прибегать к помощи третьих лиц для вывода средств с продажи курса. При этом платформа за эти действия ответственности не несет.",
	},
];

export const legalQAs: QuestionAnswer[] = [
	{
		id: 0,
		question:
			"1. Может ли курс купить юридическое лицо? Для корпоративного использования? Какие документы нужны? Кто выставляет счет на оплату?",
		answer:
			"На данный момент мы предоставляем возможность покупки для физических лиц, однако в скором времени будет предусмотрена возможность покупки для юридических лиц. Перечень документов будет указан в специальной вкладке в личном кабинете.",
	},
	{
		id: 1,
		question: "2. Могут ли мой курс скопировать/скачать с платформы?",
		answer: (
			<>
				Наша платформа не дает разрешение на копирование и распространение материала вне платформы,
				пользователю доступен только просмотр курса (см. пункт 3.9{" "}
				<Link href={DOCUMENT_LINKS.USER_AGREEMENT_URL} target="_blank">
					<u>Пользовательского соглашения</u>
				</Link>
				). И любое нарушение данного пункта будет являться нарушением правил платформы с последующим
				применением к нарушителю мер в виде деактивации аккаунта.{" "}
			</>
		),
	},
	{
		id: 2,
		question: "3. Кому будут принадлежать авторские права после размещения моего курса на платформе?",
		answer:
			"Авторские (исключительные) права на курс после размещения остаются за Вами как за автором. Автор вправе в любой момент изменять или дополнять материал курса, а так же удалить его с площадки. Платформа и пользователи получают от автора ограниченные права (лицензию) на просмотр курса на площадке. При этом даже при удалении автором курса с платформы у слушателей курса также сохраняется к нему доступ.",
	},
	{
		id: 3,
		question:
			"4. Могу ли я выдавать сертификат о прохождении моего курса на вашей платформе? Есть у вас своя система сертификатов?",
		answer: "На платформе Selfschool система сертификатов не предусмотрена.",
	},
	{
		id: 4,
		question: "5. Какие документы нужны, чтобы начать создавать курсы на вашей платформе?",
		answer: (
			<>
				Для того чтобы разместить курс, Вам необходимо зарегистрироваться на платформе и принять условия{" "}
				<Link href={DOCUMENT_LINKS.USER_AGREEMENT_URL} target="_blank">
					<u>Пользовательского соглашения</u>
				</Link>
				. Далее Вы загружаете и редактируете курс в модуле Конструктор.
			</>
		),
	},
	{
		id: 5,
		question:
			"6. Нужно ли мне подтверждать свои персональные данные, в том числе паспорт перед публикацией курса?",
		answer:
			"Подтверждение персональных данных не нужно. Когда Вы соглашаетесь с правилами использования площадки, прописанными в пользовательском соглашении, Вы подтверждаете, что являетесь дееспособным физическим лицом, действуете добросовестно, добровольно и разумно в пределах своей дееспособности, в возрасте 14 лет и старше.",
	},
	{
		id: 6,
		question: "7. Граждане каких стран могут размещать курсы на платформе?",
		answer:
			"Абсолютно любые граждане, имеющие карту российского банка, или доверенное лицо, имеющее карту российского банка, могут размещать платные курсы на платформе. Для размещения бесплатных курсов никаких географических ограничений нет.",
	},
	{
		id: 7,
		question: "8. По каким темам и направлениям категорически запрещено размещать курсы на платформе?",
		answer: (
			<>
				Запрещено размещать материалы, призывающие к насилию, ненависти, подрыву конституционного строя,
				употреблению запрещенных веществ, в также материалы, призывающие к любым действиям, идущим вразрез с
				действующим законодательством Российской Федерации. Требования к курсу указаны в пункте 5{" "}
				<Link href={DOCUMENT_LINKS.COURSE_PUBLICATION_RULES_URL} target="_blank">
					<u>Условий размещения Онлайн-курса на Платформе</u>
				</Link>
				.
			</>
		),
	},
];
